<template>
  <a v-for="link in links" :key="link.href" class="nav-link" :href="link.href">
    {{ link.label }}
  </a>
</template>

<script setup lang="ts">
/**
 * Links to the current call on isidore-project.eu, shown in the top navbar.
 *
 * App.vue teleports this component into an <li> it places in ul.navbar-nav, so
 * the links sit next to Help and inherit the navbar's collapse behaviour. The
 * styling therefore lives in src/styles/app-overrides.css instead of a scoped
 * block, as with DeploymentBadge.vue.
 *
 * They are plain same-tab anchors on purpose: the vendored menu's own nav
 * anchors assign window.location.href on click, so an item opening a new tab
 * would also navigate the current one away.
 */
import type { INavbarCallLink } from "../functions/navbarCallLinks";

defineProps<{ links: INavbarCallLink[] }>();
</script>
